import React from "react";

import dynamic from "next/dynamic";

import { WhoppahFullSize } from "@/assets/icons/Logo";
import { LazyHydrate } from "@/common/components/lazy-hydrate";
import HeaderCart from "@/components/Header/HeaderCart";
import HeaderChat from "@/components/Header/HeaderChat";
import { HeaderCreateAd } from "@/components/Header/HeaderCreateAd";
import { HeaderFavorites } from "@/components/Header/HeaderFavorites";
import HeaderLanguageSwitcher from "@/components/Header/HeaderLanguageSwitcher";
import { HeaderLogo } from "@/components/Header/HeaderLogo";
import { HeaderNotifications } from "@/components/Header/HeaderNotifications";
import { ProBuyerHeaderButton } from "@/features/pro-buyer-application/components/ProBuyerHeaderLink";
import { HeaderSearchBox } from "@/features/search/components/search-box/HeaderSearchBox";

const HeaderAccount = dynamic(
  () => import("@/components/Header/HeaderAccount"),
  { ssr: false }
);

const MegaMenu = dynamic(() =>
  import("@/components/mega-menu/MegaMenu").then(module => module.MegaMenu)
);

type HeaderDesktopProps = {
  focused?: boolean;
};

export const HeaderDesktop = ({ focused = false }: HeaderDesktopProps) => {
  // const { isUnique, finalize: finalizeUniqueness } = useUniqueVisit({
  //   trackingKey: "desktop-header-search-by-image",
  //   maxRepeatCount: 3,
  // });

  const content = focused ? (
    <>
      <HeaderLogo
        logo={<WhoppahFullSize className="mb-1 h-[24px] w-[87px]" />}
      />
      <div className="flex-1" />
      <HeaderLanguageSwitcher focused={true} />
    </>
  ) : (
    <>
      <HeaderLogo
        logo={
          <WhoppahFullSize className="h-[34px] w-[130px] lg:h-[45px] lg:w-[172px]" />
        }
      />
      <HeaderSearchBox />
      <div className="flex shrink-0 items-center">
        <HeaderFavorites />
        <HeaderCart />
        <HeaderAccount />
        <HeaderChat />
        <HeaderNotifications />
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <HeaderCreateAd />
        <ProBuyerHeaderButton />
      </div>
    </>
  );

  /*
   * This whole header is `display: none` below `md`, but phones hydrated the
   * mega-menu anyway: ~850 elements, over half of the homepage's markup.
   * LazyHydrate skips it while hidden and hydrates it as usual on desktop.
   */
  const menu = focused ? null : (
    <LazyHydrate>
      <MegaMenu />
    </LazyHydrate>
  );

  return (
    <div className="hidden flex-col space-y-6 border-b border-b-[#b0b0b0] border-opacity-40 bg-white px-6 pt-1 md:flex lg:px-12 xl:px-24">
      <div className="flex items-center space-x-3 lg:space-x-8">{content}</div>
      {menu}
    </div>
  );
};
